import { MonitorPlugin } from "./monitor-plugin";
import { MonitorPluginService } from "./monitor-plugin-service";
import { showPluginMonitorForm } from "../../../components/forms/plugin-monitor-form";
import { MonitorSignalChips } from "../MonitorSignalChips";

// The generic kind for a monitor naming a checkpoint monitor plugin (plugin_fileset_uid, plugin_name): any plugin a fileset
// registers, with a form generated from the plugin's configuration type (plugin-monitor-form.ts). Add
// Monitor lists the registered plugins themselves (MonitorPluginService.addMonitorEntries); a monitor row
// whose plugin no hand-written kind claims resolves to this kind, so it can be edited, and its chips in
// the monitors list are the readings the plugin's `signals` literal names (core.monitor Signal), under
// the plugin's kind as the readings' category. FEATURE-20261021-check-config-type-and-fileset-form.
const checkpointPluginKind: MonitorPlugin = {
  kind: "checkpoint-plugin",
  title: "Checkpoint plugin monitor",
  description: "A monitor from a monitor plugin a fileset registers; its form is generated from the plugin's configuration type.",
  icon: "Extension",
  openForm: () => undefined,
  signalCategory: "",
  signalKeys: [],
  renderSignal: () => null,
  renderDetail: () => null,
};

MonitorPluginService.get().registerFallback((row, pluginName) => {
  const filesetUid = row.plugin_fileset_uid ?? "";
  if (!filesetUid) return undefined;
  const registered = MonitorPluginService.get().registration(pluginName);
  const keys = registered?.signals ?? [];
  return {
    ...checkpointPluginKind,
    kind: `plugin:${pluginName}`,
    title: registered?.title || pluginName,
    openForm: (target) =>
      showPluginMonitorForm({ filesetUid, plugin: pluginName, monitorUid: (target as { monitorUid?: string } | undefined)?.monitorUid }),
    signalCategory: registered?.kind ?? "",
    signalKeys: keys,
    renderSignal: (readings) => (keys.length ? <MonitorSignalChips readings={readings} keys={keys} /> : null),
  };
});
